export const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const PHONE_PATTERN = /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;
export const ZIP_PATTERN = /^\d{5}$/;

export const PASSWORD_RULES = [
  { key: 'length', label: 'At least 8 characters in length', test: (p: string) => p.length >= 8 },
  {
    key: 'special',
    label: 'Contain at least one special character',
    test: (p: string) => /[`~!@#$%^&*()_+=|\\{}[\]"':;/?<>,.-]/.test(p),
  },
  { key: 'upper', label: 'Have one uppercase letter', test: (p: string) => /[A-Z]/.test(p) },
  { key: 'lower', label: 'Have one lowercase letter', test: (p: string) => /[a-z]/.test(p) },
] as const;

export const isStrongPassword = (p: string): boolean => PASSWORD_RULES.every((r) => r.test(p));

/** `(555) 555-5555` as the user types; digits only, capped at ten. */
export function formatPhone(raw: string): string {
  const d = raw.replace(/\D/g, '').slice(0, 10);
  if (d.length < 4) return d;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

/** "a" or "an" before a profession name. */
export function withArticle(noun: string): string {
  return `${/^[aeiou]/i.test(noun) ? 'an' : 'a'} ${noun}`;
}
